import {
  IContractSearchQuery,
  ITerm,
  ITermSearchFilter,
  SearchFilterOperator,
  SearchFilterOperatorNames,
} from '@dealpoint/types'

export default function getKeyTermQueryDescription(
  terms: ITerm[],
  {
    contractInformationFilters = [],
    keyTermFilters = [],
    query,
    signedAfter,
    signedBefore,
  }: IContractSearchQuery
): string {
  const searchDescriptionParts: string[] = []

  if (query?.length) {
    searchDescriptionParts.push(`Contains "${query}"`)
  }

  if (signedAfter) {
    searchDescriptionParts.push(`signed after ${new Date(signedAfter).toLocaleDateString()}`)
  }

  if (signedBefore) {
    searchDescriptionParts.push(`signed before ${new Date(signedBefore).toLocaleDateString()}`)
  }

  const getFilterDescription = createGetFilterDescription(terms)

  contractInformationFilters.forEach((filter) => {
    const description = getFilterDescription(filter)
    if (description) {
      searchDescriptionParts.push(description)
    }
  })

  keyTermFilters.forEach((filter) => {
    const description = getFilterDescription(filter)
    if (description) {
      searchDescriptionParts.push(description)
    }
  })

  return searchDescriptionParts.join(' AND ')
}

const createGetFilterDescription = (terms: ITerm[]) => (filter: ITermSearchFilter) => {
  const values = filter.value.map((v) => {
    const numberValue = Number(v)

    return isNaN(numberValue)
      ? `"${v}"`
      : numberValue.toLocaleString(undefined, {
          maximumFractionDigits: 2,
          minimumIntegerDigits: 0,
        })
  })

  const termType = terms.find((termType) => termType.id === filter.termId)
  if (termType) {
    return `${termType.title} ${SearchFilterOperatorNames[filter.operator]}${
      values.length ? ` ${values.join(' or ')}` : ''
    }`
  }

  return ''
}
